import {
    GET_ALL_SKETCH_ORDER_COUNTS_REQUEST,
    GET_ALL_SKETCH_ORDER_COUNTS_SUCCESS,
    GET_ALL_SKETCH_ORDER_COUNTS_FAILURE,
    UPDATE_ALL_SKETCH_ORDER_COUNTS,
} from '../actions/actionTypes';

const initState = {
    isFetchingCounts: false,
    isFetchingOrdersInTheQueue: false,
    totalOrdersInTheQueue: 0,
    isFetchingOrdersInTheVendorQueue: false,
    totalOrdersInTheVendorQueue: 0,
    isFetchingOrdersPendingSketchOsAdmin: false,
    totalOrdersPendingSketchOsAdmin: 0,
    isFetchingExceptionOrders: false,
    totalExceptionOrders: 0,
    isFetchingMyOrdersInProgress: false,
    totalMyOrdersInProgress: 0,
    isFetchingBillingFailedOrders: false,
    totalBillingFailedOrders: 0,
    totalRushOrders: 0,
    filteredRushOrders: 0,
    pendingMetalRoofOrders: 0,
};

const dashboardReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_ALL_SKETCH_ORDER_COUNTS_REQUEST:
            return Object.assign({}, state, {
                isFetchingCounts: true,
            });
        case GET_ALL_SKETCH_ORDER_COUNTS_SUCCESS:
            const totals = action.response.sketchOrderTotalsSummary;
            
            return Object.assign({}, state, {
                isFetchingCounts: false,
                totalOrdersInTheQueue: totals.pending,
                totalOrdersInTheVendorQueue: totals.pendingVendor,
                totalOrdersPendingSketchOsAdmin: totals.pendingAdminApproval,
                totalMyOrdersInProgress: totals.myOrdersInProgress,
                totalBillingFailedOrders: totals.failedToBill,
                totalExceptionOrders: totals.needsAttention,
                totalRushOrders: totals.rushOrders,
                filteredRushOrders: totals.filteredRushOrders,
                pendingMetalRoofOrders: totals.pendingMetalRoofOrders,
            });
        case GET_ALL_SKETCH_ORDER_COUNTS_FAILURE:
            return Object.assign({}, state, {
                isFetchingCounts: false,
            });
        case UPDATE_ALL_SKETCH_ORDER_COUNTS:
            const orders = action.payload
            return Object.assign({}, state, {
                totalOrdersInTheQueue: orders.pending,
                totalOrdersInTheVendorQueue: orders.pendingVendor,
                totalOrdersPendingSketchOsAdmin: orders.pendingAdminApproval,
                totalBillingFailedOrders: orders.failedToBill,
                totalExceptionOrders: orders.needsAttention,
                totalRushOrders: orders.rushOrders,
                filteredRushOrders: orders.filteredRushOrders,
                pendingMetalRoofOrders: totals.pendingMetalRoofOrders,
            })
        default:
            return state;
    }
};

export default dashboardReducer;
